export const getGroupIdAndNonGroupElements = (elements = []) => {
  let groupId;
  const groupElements = new Set();
  const nonGroupElements = new Set();
  const groupIds = new Set();
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const gId = element.getAttribute('data-group-uuid');
    if (gId) {
      if (!groupId) {
        groupId = gId;
      }
      groupIds.add(gId);
      groupElements.add(element);
    } else {
      nonGroupElements.add(element);
    }
  }
  return {
    groupId,
    nonGroupElements: Array.from(nonGroupElements),
    groupElements: Array.from(groupElements),
    groupIds: Array.from(groupIds),
  };
};

 export const scrollToTarget = (parent, child, horizontal = false, smoothScroll = true) => {
  const { top: parentTop, left: parentLeft } = parent?.getBoundingClientRect();
  const { top, left } = child.getBoundingClientRect();
  const scrollOptions = {
    top: parent.scrollTop + top - parentTop - 50,
    left: horizontal ? parent.scrollLeft + left - parentLeft - 50 : undefined,
  }
  if (smoothScroll) {
    scrollOptions.behavior = 'smooth';
  }
  parent.scrollTo(scrollOptions);
};

export const scrollToElement = tagInfo => {
  const { flowUUID, blockUUID, groupId, scrollToPage } = tagInfo;
  const editingContainerDOM = document.getElementById(`editingContainer-${flowUUID}-0`);
  editingContainerDOM && editingContainerDOM.dispatchEvent(new CustomEvent('alreadyScrolled'));
  if (!blockUUID || !flowUUID) return;
  requestAnimationFrame(() => {
    const complexPageWrapper = document.getElementById('complex-page-wrapper');
    const blockElement = document.getElementById(blockUUID);
    if (scrollToPage) {
      scrollToTarget(complexPageWrapper, editingContainerDOM);
    } else {
      const groupElements = [...document.querySelectorAll(`[data-group-uuid="${groupId}"]`)];
      if (groupElements.length === 0) return;
      const target = groupElements[0];
      const pageContent = document.getElementById(flowUUID);
      const verticalLayout = document.getElementById(`vertical-layout-${flowUUID}-0`);
      if (pageContent.getBoundingClientRect().height > verticalLayout.scrollHeight) {
        scrollToTarget(complexPageWrapper, target, true);
      } else {
        scrollToTarget(verticalLayout, target);
        setTimeout(() => {
          scrollToTarget(complexPageWrapper, target, true);
        }, 500);
      }
      setTimeout(() => {
        blockElement.dispatchEvent(
          new CustomEvent('focusGroupElement', { detail: { groupId: groupId } }),
        );
      }, 10);
    }
  });
};
